let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1WUzB")).then(() => parcelRequire('2bDPW'));